export default __webpack_public_path__ + "static/media/airstrapz-wht-1.792c0055.png";